import { createFileRoute } from "@tanstack/react-router";
import { AgeGroupPage } from "@/components/site/age-group";
import { fixturesQuery, newsByCategoryQuery, squadQuery } from "@/lib/site-queries";

export const Route = createFileRoute("/national-team/u17")({
  head: () => ({
    meta: [
      { title: "Argentina U17 | Argentinian.Soccer" },
      { name: "description", content: "Argentina U17 news, fixtures, squad and statistics." },
      { property: "og:title", content: "Argentina U17 | Argentinian.Soccer" },
      { property: "og:url", content: "/national-team/u17" },
    ],
    links: [{ rel: "canonical", href: "/national-team/u17" }],
  }),
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(newsByCategoryQuery("national_team", 4)),
      context.queryClient.ensureQueryData(fixturesQuery("u17", 6)),
      context.queryClient.ensureQueryData(squadQuery("u17")),
    ]),
  component: () => <AgeGroupPage scope="u17" title="Argentina U17" eyebrow="U17" />,
});
